/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios";

export default {
  getOrderRequestApproval({ commit }, requestId) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/v1/order-approval/" + requestId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },  

  updateOrderRequestApproval({ commit }, { requestId, status, approverId, notes }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/order-approval/${requestId}/status`, {
          status,
          approverId,
          notes
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  createApprovalRequest({ commit }, data) {
      return axios.post('/api/v1/order-approval/create-request/', data);
  },
};
